import React from 'react';
import ReactDOM from 'react-dom';
import CustomerFormButton from './CustomerFormButton.jsx';
import OrderForm from './OrderForm.jsx';
import StockManagerContextProvider from './StockManagerContext.jsx';

if ( document.getElementById('StockManagerComponents') ) {

    ReactDOM.render(<StockManagerContextProvider>
        <OrderForm getMethods={methods => window.OrderForm = methods} />
        <CustomerFormButton startVisible={window.dev === true} getMethods={methods => window.CustomerForm = methods} />
    </StockManagerContextProvider>, document.getElementById('StockManagerComponents'));

}